import { ReactElement } from 'react';
import { Trans } from 'react-i18next';
import { UIIcon, UIText } from '@/ui';
import { backgroundMedium, charcoal, moonlight } from '@/ui/styles';
import { useDevicesTranslation } from '../hooks';

/**
 * Informational callout for device-config edit modals, explaining that a saved
 * change is queued and shows as Pending until the device downloads it. Generic
 * wording so it can be shared across fall, tilt, geofence and Wi-Fi modals.
 */
export function PendingConfigNote(): ReactElement {
    const { t } = useDevicesTranslation();
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 12,
                padding: 16,
                borderRadius: 12,
                border: `1px solid ${moonlight}`,
                backgroundColor: backgroundMedium
            }}
        >
            <div style={{ flexShrink: 0, display: 'flex', marginTop: 2 }}>
                <UIIcon name="info" size={18} color={charcoal} />
            </div>
            <UIText type="default2">
                <Trans
                    t={t}
                    i18nKey="components.pending_config_note.body"
                    components={{
                        note: <UIText type="default2" bold />,
                        status: <UIText type="default2" bold />
                    }}
                />
            </UIText>
        </div>
    );
}
